import script from "./psiShopInGoodsGoods.vue?vue&type=script&setup=true&lang=js"
export * from "./psiShopInGoodsGoods.vue?vue&type=script&setup=true&lang=js"

import "./psiShopInGoodsGoods.vue?vue&type=style&index=0&id=37fd071d&scoped=true&lang=css"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37fd071d"]])

export default __exports__